<template>
  <div>
    <v-container fluid class="pa-7">
      <HeaderComponent
        class="pb-4"
        :title="getOrder && !loading ? `${$vuetify.lang.t('$vuetify.ecoChallengeDetail.title')} ${getOrder.externalId}` : $vuetify.lang.t('$vuetify.ecoChallengeDetail.title')"
      />

      <v-row>
        <v-col cols="12">
          <v-row v-if="getOrder && !loading">
            <v-col cols="12" lg="8">
              <UniversalCardComponent
                :title="$vuetify.lang.t('$vuetify.ecoChallengeDetail.status')"
                :info="$vuetify.lang.t('$vuetify.ecoChallengeStatus.' + getOrder.status)"
              ></UniversalCardComponent>

              <ItemsCardComponent :order="getOrder"></ItemsCardComponent>

              <UniversalCardComponent
                :title="$vuetify.lang.t('$vuetify.ecoChallengeDetail.note')"
                :info="getOrder.note"
              ></UniversalCardComponent>

              <UniversalCardComponent
                :title="$vuetify.lang.t('$vuetify.ecoChallengeDetail.transport')"
                :info="$vuetify.lang.t('$vuetify.ecoChallengeType.' + getOrder.type)"
              ></UniversalCardComponent>

              <UniversalCardComponent
                :title="$vuetify.lang.t('$vuetify.ecoChallengeList.consignment_code')"
                :info="getOrder.payload.consignment_code ? getOrder.payload.consignment_code : '-'"
              ></UniversalCardComponent>
            </v-col>

            <v-col cols="12" lg="4">
              <CustomerCardComponent :order="getOrder"></CustomerCardComponent>

              <AddressCardComponent :order="getOrder"></AddressCardComponent>

              <InvoiceCardComponent :order="getOrder"></InvoiceCardComponent>

              <InfoCardComponent :order="getOrder"></InfoCardComponent>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12">
              <div class="d-flex align-center justify-center">
                <v-progress-circular :size="35" color="primary" indeterminate :width="3" />
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import HeaderComponent from '../../components/layout/HeaderComponent.vue';
import UniversalCardComponent from '../../components/orders/UniversalCardComponent.vue';
import ItemsCardComponent from '../../components/orders/ItemsCardComponent.vue';
import CustomerCardComponent from '../../components/orders/CustomerCardComponent.vue';
import AddressCardComponent from '../../components/orders/AddressCardComponent.vue';
import InfoCardComponent from '../../components/orders/InfoCardComponent.vue';
import InvoiceCardComponent from '../../components/orders/InvoiceCardComponent.vue';

export default {
  name: 'EcoOrderDetail',

  components: {
    HeaderComponent,
    UniversalCardComponent,
    ItemsCardComponent,
    CustomerCardComponent,
    AddressCardComponent,
    InfoCardComponent,
    InvoiceCardComponent
  },

  data() {
    return {
      loading: true,
    }
  },

  computed: {
    ...mapGetters({
      status: 'orders/getStatus',
      getOrder: 'orders/getOrder',
      getUser: 'auth/getUser',
      userRoles: 'auth/getUserRoles',
    }),

  },

  watch: {
    '$route.params.id': {
      handler() {
        this.loadOrder()
      },
    },
  },

  methods: {
    ...mapActions({
      fetchEcoOrder: 'orders/fetchFullOrder',
      updateCredits: 'orders/updateCredits',
      clearOrder: 'orders/clearOrder',
    }),

    async loadOrder() {
      await this.clearOrder()

      this.loading = true

      await this.$nextTick()

      try {
        await this.fetchEcoOrder(this.$route.params.id)
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
  },

  created() {
    this.loadOrder()
  },
}
</script>

<style lang="scss">

</style>
